import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Tickets = loadable(() => pMinDelay(import('./Tickets'), 300), {
  fallback: <Loading />
});

const AsyncTickets = props => {
  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'none',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation bg-solid-grey auto-height`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Tickets { ...props }/>
    </ApplicationLayout>
  );
};

AsyncTickets.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncTickets;
